import { useState, useEffect } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { formatDate, getAllData, subtractDays } from '../../../shared/constants'

const LearningScoreReport = () => {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })

  const filterData = state.data
  const [page, setPage] = useState(1)

  //? useEffect
  useEffect(() => {
    getAllData('GET_LEARNING_SCORE_CARD', { page: page, limit: 10 }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  console.log({ filterData })
  console.log({ state })

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item, index) => {
      return [{ value: index + 1 }, { value: item.category }, { value: item.employee }, { value: item.monthlyQuiz }, { value: item.productQuiz }, { value: item.averageScore }]
    })
  }

  const layoutProps = {
    heading: 'Learning & Development Score Card Report',
    filename: 'learningScoreReport',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    <CustomTableLayout
      tableHeadings={['S no.', 'Category', 'Employee', 'Monthly Quiz', 'Product Quiz', 'Average Score']}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}

export default LearningScoreReport
